import { local } from '@farmersdog/utils';

export const HUMAN_ID_KEY = 'human-id';

function get(): string | null {
  return local.getItem(HUMAN_ID_KEY);
}

function set(id: string): void {
  local.setItem(HUMAN_ID_KEY, id);
}

function remove(): void {
  local.removeItem(HUMAN_ID_KEY);
}

export const humanId = {
  get,
  set,
  remove,
};
